/*global setTimeout setInterval clearInterval*/
import React from 'react'
import { WINNER_TICKET } from '../../constants/accountConstants'
import { postRequest } from '../../actions/gameAction'
import { connect } from 'react-redux'

const REVEAL_DELAYS = [5000, 10000, 15000, 20000]
const SPIN_INTERVAL = 80

class SlotNumber extends React.Component {
  state = {
    display: ['0', '0', '0', '0'],
    active: [false, false, false, false],
  }

  componentDidMount() {
    this._runOnce = true
    this._intervals = REVEAL_DELAYS.map((delay, index) =>
      setInterval(() => {
        this.setState(prev => {
          const display = [...prev.display]
          display[index] = String(Math.floor(Math.random() * 10))
          return { display }
        })
      }, SPIN_INTERVAL)
    )
    REVEAL_DELAYS.forEach((delay, index) => {
      setTimeout(() => {
        clearInterval(this._intervals[index])
        this.setState(prev => {
          const display = [...prev.display]
          const active = [...prev.active]
          display[index] = this.props.number[index]
          active[index] = true
          return { display, active }
        })
      }, delay)
    })
  }

  componentWillUnmount() {
    this._intervals.forEach(clearInterval)
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (this._runOnce) {
      this._runOnce = false
      this.props.dispatch(
        postRequest('/player/winner_ticket', {
          type: WINNER_TICKET,
          values: { game: { code: this.props.match.params.game_code }, ticket: np.number },
        })
      )
    }
    if (np.account.winner && np.account.winner.username && this._getWinner) {
      this._getWinner = false
      setTimeout(() => {
        this.props.showPlayerName(true, np.account.winner.username)
      }, 25000)
    }
  }

  _getWinner = true
  _runOnce = true

  render() {
    const { display, active } = this.state
    return (
      <div className="slots-row">
        {display.map((digit, index) => (
          <div key={index} className={`number-box ${active[index] ? 'active-number' : ''}`}>
            {digit}
          </div>
        ))}
      </div>
    )
  }
}
function mapStateToProps(store) {
  return {
    account: store.account,
  }
}

export default connect(mapStateToProps)(SlotNumber)
